import { HttpEvent, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { UserService } from "./user.service";
import { EMPTY, first, firstValueFrom, map, Observable, switchMap, take } from "rxjs";
import { AuthService } from "@auth0/auth0-angular";
import { Injectable } from "@angular/core";

const bypassRoutes = ['/validate'];

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor (private userService: UserService, private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(bypassRoutes.some(x => req.url.includes(x))) return next.handle(req);

    if (this.isTokenExpired()) {
      return this.authService.isAuthenticated$.pipe(
        switchMap((auth) => {
          if(!auth) return EMPTY;

          return this.authService.getAccessTokenSilently().pipe(
            switchMap((token: string) => {
              return this.authService.idTokenClaims$.pipe(
                take(1),
                switchMap((claims) => {
                  if(!claims) return EMPTY;
                  const tokenInfo = {
                    company: localStorage.getItem('companyName') ?? 'No disponible',
                    access_token: token,
                    id_token: claims.__raw,
                    scope: 'openid profile email',
                    expires_in: 86400,
                  };
                  return this.userService.getToken(tokenInfo);
                })
              );
            }),
            switchMap((value) => {
              if(!value) return EMPTY;
              const reqClone = req.clone({
                setHeaders: { Authorization: `Bearer ${value.token}` }
              });
              return next.handle(reqClone);
            })
          );
        })
      );
    } else {
      const tokenData = JSON.parse(localStorage.getItem('token_data') ?? "{}");
      if(tokenData.token) {
        const tokenInfo = {
          company: localStorage.getItem('companyName') ?? 'No disponible',
          access_token: tokenData.token,
          id_token: localStorage.getItem("token_id") ?? "",
          scope: 'openid profile email',
          expires_in: 86400,
        };
        return this.userService.getToken(tokenInfo).pipe(switchMap((value) => {
          if(value) {
            const reqClone = req.clone({
              setHeaders: { Authorization: `Bearer ${value.token}` }
            });
            return next.handle(reqClone);
          }

          return next.handle(req);
        }))
      }
    }

    return next.handle(req);
  }


  private isTokenExpired(): boolean {
    const tokenData = localStorage.getItem('token_data');
    if (!tokenData) return true;
    
    const parsed = JSON.parse(tokenData);
    const expiresAt = parsed.expires_at ?? parsed.expiration;
    if (!expiresAt) return true;
    return Date.now() >= expiresAt;
  }

  setTokenExpiration(expiresIn: number): void {
    const expiresAt = Date.now() + (expiresIn * 1000);
    localStorage.setItem('token_data', JSON.stringify({ expires_at: expiresAt }));
  }

}
